import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { TruckEntity, TruckRequestEntity } from 'src/entities/truckEntity';

export const useMutationTruck = () => {
  const queryClient = useQueryClient();
  return {
    addTruck: useMutation({
      mutationFn: (trucks: TruckRequestEntity) => axios.post('/api/v2/trucks', trucks),

      onSuccess: () => queryClient.invalidateQueries({
        queryKey: ['trucks']
      })
    }),
    updateTruck: useMutation({
      mutationFn: (trucks: TruckEntity) => axios.put(`/api/v2/trucks/${trucks.id}`, trucks),

      onSuccess: (res) => queryClient.invalidateQueries({
        queryKey: ['trucks']
      })
    }),
    deleteTrucks: useMutation({
      mutationFn: (ids: number[]) => axios.delete('/api/v2/trucks/bulk', { data: { ids } }),

      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: ['trucks']
        });
        void queryClient.invalidateQueries({
          queryKey: ['drivers']
        });
      }
    }),
  };
};
